import React from 'react'
import { createPortal } from 'react-dom'
import { usePageContext } from './PageContext'

/**
 * Renders actions into the header of the surrounding `Page`, so pages rendered inside a shared layout
 * (e.g. settings pages under SettingLayout) can place their buttons in the page header. Put the primary
 * action last so it ends up rightmost. Outside a `Page` the actions render in place.
 */
const PageActions: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const page = usePageContext()

  if (!page) return <>{children}</>
  return page.actionsNode ? createPortal(children, page.actionsNode) : null
}

export default PageActions
